export const getBrandingData = async (widgetKey, shouldSkipCache = false, signal) => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
    const url = new URL(`${baseUrl}/v2/fetch-bubble-branding/${encodeURIComponent(widgetKey)}`);
    if (shouldSkipCache) {
        url.searchParams.set("_refresh", Date.now().toString());
    }
    const response = await fetch(url, { credentials: "omit", signal });
    if (!response.ok) {
        throw new Error(`Widget branding validation failed (HTTP ${response.status})`);
    }
    const data = await response.json();
    if (!data || data.type === "error" || !data.ule) {
        throw new Error("Widget branding configuration is unavailable");
    }
    return data;
};
